import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MethodSection } from './components/MethodSection';
import { OfferDetails } from './components/OfferDetails';
import { HowItWorks } from './components/HowItWorks';
import { SocialProof } from './components/SocialProof';
import { PricingCTA } from './components/PricingCTA';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen w-full bg-cream selection:bg-amber/30 selection:text-chocolate-dark" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <MethodSection data-id="element-3" />
      <OfferDetails data-id="element-4" />
      <HowItWorks data-id="element-5" />
      <SocialProof data-id="element-6" />
      <PricingCTA data-id="element-7" />
      <footer className="py-8 px-6 text-center text-sm" style={{
      backgroundColor: '#3C1518',
      color: '#FFF8F0'
    }} data-id="element-8">
        <p data-id="element-9">
          © {new Date().getFullYear()} Repostería de Guerra. Todos los derechos
          reservados.
        </p>
      </footer>
    </main>;
}